/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EvmErc20TransferListInfo } from '../models/EvmErc20TransferListInfo';
import type { EvmTokenHolderListInfo } from '../models/EvmTokenHolderListInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class EvmErc20ControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns EvmErc20TransferListInfo OK
     * @throws ApiError
     */
    public getEvmErc20TransferList({
        ca,
        page = 1,
        size = 25,
    }: {
        ca?: string,
        page?: number,
        size?: number,
    }): CancelablePromise<EvmErc20TransferListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/token/ERC20/transfer/list',
            query: {
                'ca': ca,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmErc20TransferListInfo OK
     * @throws ApiError
     */
    public getEvmErc20TransferList1({
        ca,
        page = 1,
        size = 25,
    }: {
        ca?: string,
        page?: number,
        size?: number,
    }): CancelablePromise<EvmErc20TransferListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/token/ERC20/transfer/list',
            query: {
                'ca': ca,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmTokenHolderListInfo OK
     * @throws ApiError
     */
    public getEvmErc20HolderList({
        ca,
        page = 1,
        size = 25,
    }: {
        ca: string,
        page?: number,
        size?: number,
    }): CancelablePromise<EvmTokenHolderListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/token/ERC20/holder/list',
            query: {
                'ca': ca,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmTokenHolderListInfo OK
     * @throws ApiError
     */
    public getEvmErc20HolderList1({
        ca,
        page = 1,
        size = 25,
    }: {
        ca: string,
        page?: number,
        size?: number,
    }): CancelablePromise<EvmTokenHolderListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/token/ERC20/holder/list',
            query: {
                'ca': ca,
                'page': page,
                'size': size,
            },
        });
    }

}
